import * as yup from 'yup';
import { API as ArrivalDepartureFormality } from '../../../arrivalDepartureFormality/api';

export const BuoyConf = {
  schema: {
    id_arrival_departure_formality: yup
      .object()
      .nullable()
      .required('Service is required'),
  },
  defaultValues: {
    id_arrival_departure_formality: null,
  },
  fields: [
    {
      id: 'id_arrival_departure_formality',
      name: 'id_arrival_departure_formality',
      type: 'async_autocomplete',
      label: 'Service',
      api: ArrivalDepartureFormality.selectBuoyReservation,
      required: true,
      xs: 12,
      sm: 6,
    },
  ],
};
